import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function Winner() {
    const navigate = useNavigate();

    const items = [
        {
                    'option': 'AirPods',
                    'src': '../img/AirPods.jpg',
                    'order': 1,
                    'label': 'AirPods Pro3'
                }, {
                    'option': 'Sharp',
                    'src': '../img/Sharp.jpg',
                    'order': 2,
                    'label': 'SHARP 加湿空気清浄機'
                }, {
                    'option': 'Echo',
                    'src': '../img/Echo.jpg',
                    'order': 3,
                    'label': '(スマートホームセット) Amazon Echo Dot + NatureRemo3'
                }, {
                    'option': 'Bruno',
                    'src': '../img/Bruno.png',
                    'order': 4,
                    'label': 'BRUNO ホットプレート'
                }, {
                    'option': 'Terra',
                    'src': '../img/Terra.jpg',
                    'order': 5,
                    'label': 'ソーダストリーム TERRA'
        },
        {
                    'option': 'Lamdash',
                    'src': '../img/Lamdash.jpg',
                    'order': 6,
                    'label': 'Panasonic ラムダッシュパームイン'
                }, {
                    'option': 'Kassa',
                    'src': '../img/Kassa.jpg',
                    'order': 7,
                    'label': 'Panasonic リフトケア美顔器 バイタリフト かっさ'
                }, {
                    'option': 'Mytrex',
                    'src': '../img/Mytrex.jpg',
                    'order': 8,
                    'label': 'MYTREX ヒートネック'
                }, {
                    'option': 'Shiro',
                    'src': '../img/Shiro.jpg',
                    'order': 9,
                    'label': 'SHIRO ルームフレグランス'
                }, {
                    'option': 'Aesop',
                    'src': '../img/Aesop.jpg',
                    'order': 10,
                    'label': 'Aesop アロマティック ハンドウォッシュ'
        },
        {
                    'option': 'Experience',
                    'src': '../img/Experience.jpg',
                    'order': 11,
                    'label': '体験型Gift Premium ペア'
                }, {
                    'option': 'Disney',
                    'src': '../img/disney.jpg',
                    'order': 12,
                    'label': 'ディズニーチケット ペア'
                }, {
                    'option': 'Tea',
                    'src': '../img/Tea.jpg',
                    'order': 13,
                    'label': '高級ホテルアフタヌーンティ ペア'
                }, {
                    'option': 'Hiruton',
                    'src': '../img/Hiruton.jpg',
                    'order': 14,
                    'label': 'ヒルトン東京日本料理食事券 ペア'
                }, {
                    'option': 'Spa',
                    'src': '../img/Spa.jpg',
                    'order': 15,
                    'label': 'Times Spa Resta 利用券 ペア'
                }, {
                    'option': 'Sauna',
                    'src': '../img/Sauna.jpg',
                    'order': 16,
                    'label': 'サウナスパ利用券 1~2名'
                }, {
                    'option': 'Cafe',
                    'src': '../img/Cafe.jpg',
                    'order': 17,
                    'label': 'カフェ利用券'
        },
        {
                    'option': 'Matsuzaka',
                    'src': '../img/Matsuzaka.jpg',
                    'order': 18,
                    'label': '松坂牛 サーロインステーキ 200g×2'
                }, {
                    'option': 'Crab',
                    'src': '../img/Crab.jpg',
                    'order': 19,
                    'label': '北海道産 ボイル毛ガニ 2尾'
                }, {
                    'option': 'Conger',
                    'src': '../img/Conger.jpg',
                    'order': 20,
                    'label': '淡路島 焼きアナゴ 5本セット'
                }, {
                    'option': 'Sukiyaki',
                    'src': '../img/Sukiyaki.jpg',
                    'order': 21,
                    'label': '三田和牛 肩ロース すき焼き 300g'
                }, {
                    'option': 'Shabu',
                    'src': '../img/Shabu.jpg',
                    'order': 22,
                    'label': '平田牧場 三元豚しゃぶしゃぶ'
                }, {
                    'option': 'Kobe',
                    'src': '../img/Kobe.jpg',
                    'order': 23,
                    'label': '神戸牛 すき焼き用 モモ肉 250g'
                }, {
                    'option': 'Sensuke',
                    'src': '../img/Sensuke.jpg',
                    'order': 24,
                    'label': '日本酒 仙介 純米大吟醸 720ml'
                }, {
                    'option': 'Rice',
                    'src': '../img/Rice.jpg',
                    'order': 25,
                    'label': '長岡産 コシヒカリ 5kg'
                }, {
                    'option': 'Melon',
                    'src': '../img/Melon.jpg',
                    'order': 26,
                    'label': '静岡県産 クラウンマスクメロン'
                }, {
                    'option': 'Oyster',
                    'src': '../img/Oyster.jpg',
                    'order': 27,
                    'label': '広島県産 大粒カキフライ 20個'
                }, {
                    'option': 'Ice',
                    'src': '../img/Ice.jpg',
                    'order': 28,
                    'label': '銀座千疋屋 ミルフィーユアイス'
                }, {
                    'option': 'Kaisen',
                    'src': '../img/Kaisen.jpg',
                    'order': 29,
                    'label': '能登半島 北陸海鮮漬け丼の具 6食'
                }, {
                    'option': 'Steak',
                    'src': '../img/Steak.jpg',
                    'order': 30,
                    'label': '神戸洋食 デミグラスハンバーグ 9個'
                }, {
                    'option': 'Chinese',
                    'src': '../img/Chinese.jpg',
                    'order': 31,
                    'label': '赤坂四川飯店監修 中華料理セット'
                }, {
                    'option': 'Financier',
                    'src': '../img/Financier.jpg',
                    'order': 32,
                    'label': 'シェフ・アサヤマ フィナンシェ 12個'
                }, {
                    'option': 'Ramen',
                    'src': '../img/Ramen.jpg',
                    'order': 33,
                    'label': '喜多方ラーメン 12食'
                }, {
                    'option': 'Cake',
                    'src': '../img/Cake.jpg',
                    'order': 34,
                    'label': 'ホシフルーツ 大人のチーズケーキ'
        }
    ]

    let nextVelocity = 0.1;

    // const middleStyle = "'transform': 'translate(0px, 10px)','transition': `transform ${velocity}s`"

    const topStyle = 'transform: translate(10px, -30px)';

    const middleStyle = `transform: translate(10px, 26px); transition: transform ${nextVelocity}s`;

    const bottomStyle = `transform: translate(10px, 90px); transition: transform ${nextVelocity}s`;

    let item1 = document.getElementById('item1');

    let item2 = document.getElementById('item2');

    let item3 = document.getElementById('item3');

    let isLoop = false;



    document.addEventListener('load', function () {

        item1 = document.getElementById('item1');

        item2 = document.getElementById('item2');

        item3 = document.getElementById('item3');

        item3.style = topStyle;

        item2.style = middleStyle;

        item1.style = bottomStyle;

    });
    let candidate = [];

    let isFirst = true;
    const [isFetch, setIsFetch] = useState(false);
    const [list, setList] = useState([]);


    useEffect(() => {
        getUser();
    }, []);



    const getUser = async () => {

        setIsFetch(true);

        const list = await axios.post('https://pf9ly0fx16.execute-api.ap-northeast-1.amazonaws.com/production', {
            'getWinner': true,
        }, {
            headers: {
                'x-api-key': 'tCBUbWk4Ax1Xho0B7gZeBZMr2TX8R2z7M6MtbRj8'
            }
        });
        list.data.forEach(x => {
            const temp = items.filter(y => y.option === x.option);
            if(temp.length > 0){
                x.label = temp[0].label;
                x.order = temp[0].order;
            }else{
                x.order = 999;
            }
        })
        const winner = list.data.sort((a, b) => a.order > b.order ? 1 : -1);
        const map = new Map();
        winner.forEach(({ category, ...rest }) => {
            if (!map.has(category)) {
              map.set(category, { category, option: [] });
            }
            map.get(category).option.push(rest);
        });
        const a = Array.from(map.values());
        setList(a);
        setIsFetch(false);
    }



    return (

        <div className='main'>

            <div className='header-div lotate-header'>

                <img src='./img/header-removebg-preview.png'></img>

            </div>

            <div className='body-div'>

                {isFetch

                    && <div style={{ display: 'flex' }}>

                        <div className='loader'></div>

                        <p>取得中</p>

                    </div>

                }
                {
                    !isFetch
                    &&
                    <div className='winner'>
                        {list.length > 0 && list.map((item) => (
                            <div key={item.category} style={{marginTop: '10px'}}>{item.category}
                            {item.option.map((option) => (
                                <div key={option.option}>
                                    <label>
                                        <input type="checkbox"/>
                                        {option.label}
                                        <p style={{marginTop: '-5px', marginLeft: '20px', marginBottom: '-1px'}}>{option.corporate} {option.team}チーム {option.name} さん</p>
                                    </label>
                                </div>
                            ))}
                            </div>
                        ))}

                    </div>

                }



            </div>

        </div>

    );

}



export default Winner;